export default __webpack_public_path__ + "static/theway-eee152ec4c40cdc0c52b2b8c01aa6957.jpg";